import { slice } from './slice'

const appActions = { ...slice.actions }

export default appActions
